import { useEffect } from "react";

export default function PredictReport(props) {
  useEffect(() => {
    //console.log("useffect in predict report");
  }, []);
  const { data } = props;
  return <h1>Predict {data.id}</h1>;
}
